import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, renderList as _renderList, createSlots as _createSlots, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16f83686"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "page-content" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新建角色")
const _hoisted_3 = { class: "handle-btn" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "编辑", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "删除", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_edit = _resolveComponent("edit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_delete = _resolveComponent("delete")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_ZpTable = _resolveComponent("ZpTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ZpTable, _mergeProps({
      listData: _ctx.pageList,
      listCount: _ctx.dataCount
    }, _ctx.contentConfig, {
      page: _ctx.pageInfo,
      "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageInfo) = $event))
    }), _createSlots({
      handlerBtn: _withCtx(() => [
        (_ctx.isCreate)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _ctx.handleNewClick
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      status: _withCtx((slot) => [
        _createVNode(_component_el_button, {
          size: "mini",
          type: slot.row.enable ? 'success' : 'danger'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(slot.row.enable ? '启用' : '禁用'), 1)
          ]),
          _: 2
        }, 1032, ["type"])
      ]),
      create: _withCtx((slot) => [
        _createTextVNode(_toDisplayString(_ctx.$filters.formatTime(slot.row.createAt)), 1)
      ]),
      update: _withCtx((slot) => [
        _createTextVNode(_toDisplayString(_ctx.$filters.formatTime(slot.row.updateAt)), 1)
      ]),
      handle: _withCtx((slot) => [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.isUpdate)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                size: "small",
                type: "text",
                onClick: ($event: any) => (_ctx.handleEditClick(slot.row))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_edit)
                    ]),
                    _: 1
                  }),
                  _hoisted_4
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_popconfirm, {
            title: "确定要删除吗?",
            onConfirm: ($event: any) => (_ctx.handleDeleteClick(slot.row))
          }, {
            reference: _withCtx(() => [
              (_ctx.isDelete)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    size: "small",
                    type: "text"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_delete)
                        ]),
                        _: 1
                      }),
                      _hoisted_5
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["onConfirm"])
        ])
      ]),
      _: 2
    }, [
      _renderList(_ctx.otherPropSlots, (item) => {
        return {
          name: item.slotName,
          fn: _withCtx((slot) => [
            (item.slotName)
              ? _renderSlot(_ctx.$slots, item.slotName, {
                  key: 0,
                  row: slot.row
                }, undefined, true)
              : _createCommentVNode("", true)
          ])
        }
      })
    ]), 1040, ["listData", "listCount", "page"])
  ]))
}